import React, { useEffect } from 'react';
import { Router } from 'react-router-dom';
import { Provider as StoreProvider } from 'react-redux';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { PersistGate } from 'redux-persist/integration/react';
import { LastLocationProvider } from 'react-router-last-location';
import { store, persistor } from '@state';
import { Notifier, ErrorBoundary } from '@components';
import history from '@lib/history';
import config from 'config';
import Views from '@views';

import theme from './theme';
import {
  ScrollReset,
  GoogleAnalytics,
  CookiesNotification,
} from '@devias-components';
import './mixins/chartjs';
import './mixins/moment';
import './mixins/validate';
import './mixins/prismjs';
import './assets/scss/index.scss';
import './index.css';

const App = () => {
  useEffect(() => {
    document.getElementById('favicon').href = config.FAVICON;
  }, []);

  return (
    <StoreProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Router history={history}>
                <LastLocationProvider>
                  <ErrorBoundary>
                    <ScrollReset />
                    <GoogleAnalytics />
                    <CookiesNotification />
                    <Views />
                  </ErrorBoundary>
                </LastLocationProvider>
              </Router>
              <Notifier />
            </LocalizationProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </PersistGate>
    </StoreProvider>
  );
};

export default App;
